import { call, put, takeLatest } from "redux-saga/effects";
import { GET_ProjectList, GET_ProjectDetail, POST_Project, PUT_Project, DELETE_Project, GET_ProjectMembers, POST_ProjectMember, DELETE_ProjectMember } from "../services/Project";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_ProjectListEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_ProjectList, token, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ProjectList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_ProjectDetailEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_ProjectDetail, token, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ProjectDetail", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_ProjectEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_Project, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_ProjectEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(PUT_Project, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_ProjectEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_Project, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_ProjectMembersEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_ProjectMembers, token, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ProjectMembers", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_ProjectMemberEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_ProjectMember, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_ProjectMemberEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_ProjectMember, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_ProjectList", GET_ProjectListEffect);
  yield takeLatest("GET_ProjectDetail", GET_ProjectDetailEffect);
  yield takeLatest("POST_Project", POST_ProjectEffect);
  yield takeLatest("PUT_Project", PUT_ProjectEffect);
  yield takeLatest("DELETE_Project", DELETE_ProjectEffect);
  yield takeLatest("GET_ProjectMembers", GET_ProjectMembersEffect);
  yield takeLatest("POST_ProjectMember", POST_ProjectMemberEffect);
  yield takeLatest("DELETE_ProjectMember", DELETE_ProjectMemberEffect);
}
